
  import { GForm } from '@/components/forms/GForm'
  import { Component } from 'vue-property-decorator'
  import PersonForm from '@/views/forms/custom/PersonForm.vue'
  import { PersonFormatted } from '@/store/persons/person'
  import { mapMutations } from 'vuex'

@Component({
  components: {
    PersonForm,
  },
  methods: {
    ...mapMutations('persons', ['setFoundPerson', 'setResetPhone', 'setRutError', 'setId']),
  },
})
  export default class SystemCompany extends GForm {
  setFoundPerson!: (person: PersonFormatted | null) => void;
  setResetPhone!: (phone) => void
  setId!: (id) => void
  setRutError!: (data: boolean) => void;

    beforeDestroy () {
      this.initValues()
    }

    initValues () {
      this.setId(null)
      this.setFoundPerson(null)
      this.setResetPhone(null)
      this.setRutInfo(null)
      this.setRutError(false)
      this.setBackup(null)
    }

    updateCompany () {
      this.loadNotification({
      // @ts-ignore
      message: `Empresa actualizada`,
      notificationType: 'success',
    })
    }
  }
